const jsonData = `${process.env.PUBLIC_URL}/json-data`;
export const Products = `${jsonData}/products.json`;
export const Contacts = `${jsonData}/contacts.json`;
export const Tasks = `${jsonData}/tasks.json`;
export const Chats = `${jsonData}/chats.json`;
export const ChatMembers = `${jsonData}/chatMembers.json`;
